/* Tysk katalog for locale-investment-inbox.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'investments.inboxTitle': 'Posteingang',
  'investments.inboxIntro': 'Lade Dokumente zu Käufen und Verkäufen von Fonds und Aktien hoch. Plumme liest das Dokument und bereitet die Erfassung vor.',
  'investments.supportNotice': 'Fonds und Aktien werden für Erfassung und Buchung vollständig unterstützt. Andere Anlagearten können erkannt werden, müssen derzeit aber manuell bearbeitet werden.',
  'investments.sendToEmail': 'Senden an',
  'investments.copyEmail': 'E-Mail-Adresse kopieren',
  'investments.folder': 'Ordner',
  'investments.inboxFolder': 'Posteingang',
  'investments.trashFolder': 'Papierkorb',
  'investments.documentationFolder': 'Dokumentation',
  'investments.searchDocuments': 'Dokumente durchsuchen',
  'investments.emptyFolder': 'In diesem Ordner befinden sich keine Dokumente.',
  'investments.documentNotAnalyzed': 'Bereit zur Analyse',
  'investments.superPlummaProposal': 'Vorschlag von SuperPlumma',
  'investments.reviewAndApprove': 'Prüfen und freigeben',
  'investments.notAnalyzedHelp': 'Das Dokument ist eingegangen und bereit zur Analyse.',
  'investments.restoreDocument': 'Wiederherstellen',
  'investments.sendToDocumentation': 'In Dokumentation verschieben',
  'investments.moveToTrash': 'In den Papierkorb verschieben',
  'investments.moreActions': 'Weitere Aktionen',
  'investments.registerPurchase': 'Kauf erfassen',
  'investments.registerSale': 'Verkauf erfassen',
  'investments.tradeDate': 'Handelsdatum',
  'investments.unitPrice': 'NAV / Kurs',
  'investments.previewDocumentFallback': 'Dokument',
  'investments.previewMissingFileLink': 'Dateilink fehlt',
  'investments.openDocument': 'Dokument öffnen',
  'investments.addBankAccount': '+ Bankkonto hinzufügen …',
  'investments.addBankTitle': 'Bankkonto hinzufügen',
  'investments.addBankSave': 'Konto hinzufügen',
  'investments.newBankAccountNote': 'Ein neues Bankkonto wird im Kontenplan angelegt',
  'investments.newBankAccountCode': 'Das Bankkonto erhält das nächste freie Konto der 192x-Serie: {{code}}.',
  'investments.bankName': 'Kontoname',
  'investments.bankNamePlaceholder': 'z. B. Anlagekonto',
  'investments.bankAccountNumber': 'Kontonummer',
  'investments.openingBalance': 'Anfangssaldo',
  'investments.openingBalanceDate': 'Datum des Anfangssaldos',
  'investments.bankNameRequired': 'Gib dem Bankkonto einen Namen.',
  'investments.bankNumberRequired': 'Gib die Kontonummer ein.',
  'investments.bankOpeningRequired': 'Gib Anfangssaldo und Datum des Anfangssaldos ein. Gib 0 ein, wenn der Saldo null war.',
  'investments.bankNumberExists': 'Das Bankkonto ist bereits erfasst.',
  'investments.bankLedgerSeriesFull': 'In der 192x-Serie ist kein Konto frei. Füge das Konto in den Einstellungen hinzu.',
  'investments.bankAdded': 'Bankkonto hinzugefügt.',
  'investments.addBankFailed': 'Das Bankkonto konnte nicht hinzugefügt werden.',
  'investments.addBankUnavailable': 'Bankkonten sind nicht mit dem Backend verbunden.',
  'investments.addBankUnsupportedCountry': 'Dieser Bankkonto-Ablauf wird derzeit nur für norwegische Unternehmen unterstützt.',
  'investments.newInvestmentAccount': 'Neues Anlagekonto',
  'investments.investmentAccounts': 'Anlagekonten und Depots',
  'investments.settingsTab': 'Anlagen',
  'investments.settingsTitle': 'Anlagekonten und Depots',
  'investments.settingsHelp': 'Verwalte die Konten bei Banken, Fondsanbietern und anderen Anbietern.',
  'investments.editInvestmentAccount': 'Anlagekonto bearbeiten',
  'investments.investmentAccountsHelp': 'Erfasse die Konten bei jedem Anbieter. Dieselbe Anlage kann in mehreren Depots gehalten werden, während das Hauptbuchkonto weiterhin vierstellig ist.',
  'investments.noInvestmentAccounts': 'Noch keine Anlagekonten erfasst.',
  'investments.saveInvestmentAccount': 'Anlagekonto speichern',
  'investments.investmentAccountId': 'Bank / Depot',
  'investments.targetInvestmentAccountId': 'Neue Bank / neues Depot',
  'investments.accountNumber': 'Konto- oder Depotnummer (optional)',
  'investments.defaultSettlementAccount': 'Standard-Verrechnungskonto',
  'investments.noDefaultSettlementAccount': 'Kein Standard-Verrechnungskonto',
  'investments.accountActive': 'Das Anlagekonto ist aktiv',
  'investments.custody': 'Wertpapierdepot',
  'investments.fund_account': 'Fondskonto',
  'investments.other': 'Sonstiges Anlagekonto',
  'investments.subledgerCode': 'Interne Anlagenummer',
  'investments.createInstrumentFromDocument': '{{name}} (wird beim Speichern angelegt)',
  'investments.providerHelp': 'Wo die Anlage verwahrt wird, zum Beispiel Storebrand oder Nordnet. Gib gegebenenfalls die Depotnummer an.',
  'investments.settlementAccountHelp': 'Das Konto des Unternehmens, das belastet oder gutgeschrieben wurde. Ein Handelskonto beim Anbieter muss in den Einstellungen als eigenes Bank-/Verrechnungskonto erfasst werden. Eine AS kann kein privates Aktiensparkonto (ASK) nutzen.',
  'investments.investmentAccountInvalid': 'Prüfe Name, Anbieter und Kontotyp.',
  'investments.investmentAccountNotFound': 'Das Anlagekonto existiert nicht oder ist inaktiv.',
  'investments.investmentAccountDuplicate': 'Ein Anlagekonto mit demselben Namen existiert bereits.',
  'investments.investmentAccountRequired': 'Wähle ein Anlagekonto, wenn der Anbieter mehrere Konten hat.',
  'investments.investmentAccountQuantityInvalid': 'Das gewählte Depot hat für diesen Vorgang nicht genügend erfasste Anteile.',
});
